import ProjectSession from "../project-session"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import ProjectSettings from "../../../manager/project/project-settings/project-settings";
import ProjectPropertiesFactory from "../properties/properties-factory"

const debug = false
// const debug = 'projectSessionApplyDelta'

export function projectSessionApplyDelta(projectSession:ProjectSession, data:any) {

    debug && console.log(debug, "applyDelta()", data)

    let isChanged = false

    const ignoredParamsForIsChangedState = ['latestActivityDate']

    _.mapKeys(data, (value ,key)=>{
        if (['id'].includes(key)) return;

        debug && console.log("applyDelta key=", key, "value=", value)

        // Normalize values i.e. date->moment
        switch (key) {
            case 'properties':
                value = ProjectPropertiesFactory.get(data.systemType || projectSession.systemType, value, projectSession) // - new way
                break

            case 'settings':
                if (value !instanceof ProjectSettings) {
                    value = new ProjectSettings(projectSession, value)
                }
                break

            case 'systemType':
                projectSession.properties = ProjectPropertiesFactory.get(value, data.properties || projectSession.properties.toJSON(), projectSession)
                break
        }

        // path names difference (backend vs js model)
        let paramName
        switch (key) {
            // case 'momentCreated'        : paramName = 'dateCreated'; break
            // case 'descriptionRtf'       : paramName = 'descriptionRTF'; break
            default:
                paramName = key
        }

        // @ts-ignore
        debug && console.log(debug, "_isSameValue", _isSameValue(paramName, value), projectSession[paramName], value)

        if (!_isSameValue(projectSession, paramName, value)) {

            // @ts-ignore
            projectSession[paramName] = value

            if (!ignoredParamsForIsChangedState.includes(paramName)) {
                isChanged = true
                projectSession.updatedFields.delete(paramName)
            }
        } else {
            // same value - do nothing ?
            debug && console.log("    Same value -> skip")
        }
    })

    debug && console.log(debug, "isChanged", isChanged)

    return isChanged

}

function _isSameValue(project:ProjectSession, paramName:any, value:any) {
    // @ts-ignore
    if (moment.isMoment(project[paramName])) {
        // console.log("isSameValue", DatetimeUtils.momentToDate(project[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(project[paramName], DatetimeUtils.dateToMoment(value), 'day'))
        // @ts-ignore
        return DatetimeUtils.isSame(project[paramName], DatetimeUtils.dateToMoment(value), 'day')
    } else {
        // @ts-ignore
        return _.isEqual(project[paramName],value)
    }
}